import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { type SpecailPreviewCardProps } from "./specialPreviewCard.type";

export const SpecialPreviewCard = ({ specialData, direction = "start" }: SpecailPreviewCardProps) => {
    const { onNavigate } = useNewNavigate();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    const { special_idx, special_name, imgList, title } = { ...specialData };
    return (
        <Flex w="inherit" key={special_idx} flexDir={direction === "reverse" ? "column-reverse" : "column"}>
            <Box
                position="relative"
                h={isMobile ? "360px" : "712px"}
                bg={imgList[0] ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"}
                _hover={{
                    "& .more_view_btn": {
                        opacity: 1,
                    },
                }}
            >
                <Box
                    className="more_view_btn"
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%,-50%)"
                    w="128px"
                    h="128px"
                    borderRadius="64px"
                    p="54px 19px"
                    bg="whiteAlpha.800"
                    opacity="0"
                    transition="0.3s ease-in-out"
                    textAlign="center"
                    onClick={() => onNavigate({ path: `/specials/${special_idx}` })}
                    color="#a8a8a8"
                    cursor="pointer"
                    {...FONT("comorant", 16, 700, 1.2)}
                >
                    More View
                </Box>
            </Box>
            <Center h="232px" flexDir="column">
                <Flex
                    w="100%"
                    flexDir="column"
                    gap="24px"
                    // eslint-disable-next-line no-nested-ternary
                    alignItems={direction === "start" ? "flex-start" : direction === "end" ? "flex-end" : "center"}
                >
                    <Text {...FONT("cormorant", isMobile ? 24 : 36, 300, 1.2)}>{special_name.kor}</Text>
                    <Box
                        w="inherit"
                        // eslint-disable-next-line no-nested-ternary
                        textAlign={direction === "end" ? "right" : direction === "reverse" ? "center" : "left"}
                        h="50px"
                        overflow="hidden"
                        display="-webkit-box"
                        textOverflow="ellipsis"
                        sx={{
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                        }}
                    >
                        <Text
                            textOverflow="ellipsis"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(title.kor),
                            }}
                            {...FONT("pretendard", isMobile ? 12 : 18, 300, 1.4)}
                        />
                    </Box>
                    <Flex gap="11px" cursor="pointer" onClick={() => onNavigate({ path: `/specials/${special_idx}` })}>
                        <Text {...FONT("notoSerif", 14, 400, 1.4)}>MoreView</Text>
                        <Center w="20px" h="20px" bg="#333" borderRadius="10px">
                            <Text className="material-icons-outlined" color="white">
                                chevron_right
                            </Text>
                        </Center>
                    </Flex>
                </Flex>
            </Center>
        </Flex>
    );
};
